import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import fuzzy from "fuzzy";
import { useHistory } from "react-router-dom";

import BackButton from "../../../../../library/BackButton/BackButtonNew";
import { CheckoutPosWrapper, PosGridWrapper } from "./checkoutPos.styles";
import { HeaderText, NormalText } from "../../../common/common.styles";
import PlainSearchInput from "../../../../../library/SearchInput/PlainSearch";
import PosCard from "./components/PosCard";
import { DashboardLoaderWrap } from "../../../../AuthenticatedApp/components/productCatalogue/dashboard/dashboard.styles";
import Loader from "../../../../../library/Loader";
import { useFetchPosDevices } from "../../../common/hooks/useFetchSalesCatalogueData";
import EmptyState from "../../../common/components/EmptyState";
import { EmptyPosIcon } from "../../../common/assets/icons/catalogueIcons";

const CheckoutPos = () => {
    const [searchString, setSearchString] = useState("");

    const { physicalPosTerminals, fetchPhysicalPosTerminalsState, fetchPhysicalPosTerminalCount } =
        useSelector((state) => state.posState);

    const handleFetchSalesDevices = useFetchPosDevices();
    const history = useHistory();

    const activeHardwarePos = useMemo(
        () => physicalPosTerminals?.filter((item) => item.status === 5),
        [physicalPosTerminals],
    );

    const searchedDevices = useMemo(() => {
        if (!searchString) return activeHardwarePos;
        const options = {
            extract: function (el) {
                return `${el.nameOfPos}`;
            },
        };
        const result = fuzzy.filter(searchString, activeHardwarePos, options);
        return result.map((el) => el.original);
    }, [searchString, activeHardwarePos]);

    useEffect(() => {
        handleFetchSalesDevices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (
        (fetchPhysicalPosTerminalsState === "idle" ||
            fetchPhysicalPosTerminalsState === "loading") &&
        fetchPhysicalPosTerminalCount === 0
    ) {
        return (
            <DashboardLoaderWrap>
                <Loader />
            </DashboardLoaderWrap>
        );
    }

    return (
        <CheckoutPosWrapper>
            <BackButton onClick={() => history.goBack()} />
            <div className="sales__checkout-header-wrap">
                <div>
                    <HeaderText>Checkout on POS</HeaderText>
                    <NormalText>
                        Choose the POS you'd like to process this order payment with.
                    </NormalText>
                </div>
                {activeHardwarePos?.length > 0 && (
                    <PlainSearchInput
                        placeholder={"Search POS Name"}
                        width="320px"
                        {...{ searchString, setSearchString }}
                    />
                )}
            </div>

            {activeHardwarePos?.length > 0 ? (
                <PosGridWrapper>
                    {searchedDevices.map((item, index) => (
                        <PosCard item={item} key={item + index} index={index} />
                    ))}
                </PosGridWrapper>
            ) : (
                <EmptyState
                    emptyIcon={<EmptyPosIcon />}
                    title="No POS Device Found"
                    details="You currently don’t have a POS device on this business. Reach out to your admin to order a POS device."
                />
            )}
        </CheckoutPosWrapper>
    );
};

export default CheckoutPos;
